import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';

export const redirectUrlPlugin = createRedirectUrlPlugin();
